import React from 'react';
import SettingSelectableItem from '../ui-components/SettingSelectableItem';
import { MiniAudioPlayer } from '../AudioPlayers';

type Props = {
    usersoundKey: string;
    displayedText: string;
    playbackUrl: string;
    handleClick: (userSoundKey: string) => void;
    selectedSoundKey: string;
};

const UserSoundItem = ({
    usersoundKey,
    displayedText,
    playbackUrl,
    handleClick,
    selectedSoundKey,
}: Props) => {
    return (
        <SettingSelectableItem
            key={usersoundKey}
            value={usersoundKey}
            onClick={() => handleClick(usersoundKey)}
            selected={selectedSoundKey}
        >
            <div className="flex items-center gap-1">
                <div>
                    {playbackUrl ? (
                        <MiniAudioPlayer
                            url={playbackUrl}
                            uniqueId={usersoundKey}
                        />
                    ) : null}
                </div>

                <div>{displayedText}</div>
            </div>
        </SettingSelectableItem>
    );
};

export default UserSoundItem;
